module.exports = __webpack_public_path__ + "static/media/onoiwa-plus-preview.73df0420.png";